import { bulkUpload, SetCoverImage, DeleteImage } from '../../api/images'
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['Place', 'PlaceImages'])
  },
  methods: {
    ...mapActions(['SetCurrentPlaceImages']),
    withImages (event) {
      console.log('withImages', event)
    },
    withNoImages (event) {
      console.log('withNoImages', event)
    },
    uploadImages (data) {
      // console.log('uploadImages', data)
      bulkUpload(data, this.Place.id)
        .then(
          success => {
            this.SetCurrentPlaceImages(this.PlaceImages.concat(success))
            this.setCover(0)
            // console.log(success)
          },
          error => {
            console.log(error.response)
          }
        )
    },
    setCover (index) {
      // console.log('setCover', data)
      SetCoverImage(this.Place.id, this.PlaceImages[index].id)
        .then(
          success => {
            let imgs = [...this.PlaceImages]
            for (let index = 0; index < imgs.length; index++) {
              imgs[index].cover = false
              delete imgs[index].coverImageId
            }
            imgs[index].cover = true
            this.SetCurrentPlaceImages(imgs)
            console.log(success)
          },
          error => {
            console.log(error.response)
          }
        )
    },
    removeImage (index) {
      // console.log('removeImage', data)
      DeleteImage(this.Place.id, this.PlaceImages[index].id)
        .then(
          success => {
            let imgs = [...this.PlaceImages]
            imgs.splice(index, 1)
            this.SetCurrentPlaceImages(imgs)
            // console.log(success)
          },
          error => {
            console.log(error.response)
          }
        )
    },
    setLegend (text, imageId) {
      console.log('setLegend', text, imageId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/ImageUploadMixin.js